<template>
  <div class="content">
    <ul>
      <li>
        <a href="http://www.nomo.co.jp/taiko/"><img src="../assets/cap_01.jpg"></a>
        <dl>
          <dt>01:太古：</dt>
          <dd>博多と福江を結ぶ深夜フェリー太古。博多港を23時45分に出発すると翌朝8時15分に福江港に到着できる。五島に行く前に福岡で美味しいものも楽しめるうえに、五島に到着後の時間も有効に使える。最近改装したばかりで船内は綺麗でシャワー室も完備。コンビニでお酒や軽食を買い込んで個室で楽しむのも良い。</dd>
          <dd><a href="http://www.nomo.co.jp/taiko/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://shinkamigoto.nagasaki-tabinet.com/spot/10014/" target="_blank"><img src="../assets/cap_02.jpg"></a>
        <dl>
          <dt>02:若松大橋：</dt>
          <dd>福江に行くなら太古をオススメする理由の一つが、明け方の景色。天候や季節などの条件がうまくあえば朝陽に照らされた島々や、朝もやの中に浮かぶ島々といった光景に出会える。上五島の中通島と若松島をつなぐ若松大橋の真下をくぐる瞬間も見所のひとつ。少し早起きしないといけないけれど、旅情溢れるスポットとなっている。</dd>
          <dd><a href="http://shinkamigoto.nagasaki-tabinet.com/spot/10014/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/spot/61088/" target="_blank"><img src="../assets/cap_03.jpg"></a>
        <dl>
          <dt>03:福江港ターミナル：</dt>
          <dd>いよいよ福江島に到着。４人が写真を撮っているのは五島のゆるキャラたちの顔ハメ。五島はゆるキャラが多い。ターミナルの中にはたくさんのお土産屋さん。ちょっとお腹が空いたんだったら浜口水産の「ばらもん揚げ」がオススメ。揚げたてのすり身揚げを片手にレンタカーを借りに行こう。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/spot/61088/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/spot/61657/" target="_blank"><img src="../assets/cap_04.jpg"></a>
        <dl>
          <dt>04:鬼岳：</dt>
          <dd>3年に一度山焼きが行われ、全面が美しい芝生に覆われている。その名前からは想像もできない優しさに満ちたパワースポットで、五島のシンボルの一つ。五島を一望できるこのスポットは港からも空港からもアクセスが良いので、最初の目的地にぴったり。ちょっとした山登りも楽しい。天文台があるくらい、星空も綺麗でオススメ。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/spot/61657/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/restaurant/51984/" target="_blank"><img src="../assets/cap_05.jpg"></a>
        <dl>
          <dt>05:うま亭：</dt>
          <dd>港の近くにある食堂。いつ行っても地元の方々で賑わっている。五島といえば五島うどん。トビウオを使ったあごだしのあっさりしたスープに、細くてつるっとした麺の組み合わせが五島うどんの特徴。4人が食べているのは「肉うどん」。あごだしスープに染み出す肉の旨味がたまらない。ちなみにこのお店、実は焼肉定食もおいしい。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/restaurant/51984/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/spot/682/" target="_blank"><img src="../assets/cap_06.jpg"></a>
        <dl>
          <dt>06:高浜海水浴場：</dt>
          <dd>日本有数の透明度を誇る五島の海。その中でも最も知名度が高いのが高浜海水浴場。スカイブルーからエメラルドグリーンまでゆたかな表情を見せる。白い砂浜も美しい。遠浅で波もそんなに高くないから子どもと一緒に楽しむのにも良い。海水浴場から車で3分の場所にある「魚藍観音」から見下ろすと高浜海水浴場に加えて、その奥の頓泊海水浴場までが一望できて圧巻。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/spot/682/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/spot/61164/" target="_blank"><img src="../assets/cap_07.jpg"></a>
        <dl>
          <dt>07:魚津ヶ崎公園：</dt>
          <dd>春には菜の花、夏にはひまわり、秋にはコスモス、季節の花々が歓迎してくれる公園。この地はかつて遣唐使船が最後に立ち寄った場所だといわれている。永井博さんがパッケージに描いたのはこの公園から望む海と島々。ポタージュをあたためて物思いにふけってみてはどうだろう。公園の近くには水の浦教会や楠原教会などもあるため足を伸ばしてみるのもオススメ。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/spot/61164/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/spot/61673/" target="_blank"><img src="../assets/cap_08.jpg"></a>
        <dl>
          <dt>08:荒川：</dt>
          <dd>荒川といえば釣り。近所の釣具屋さんで道具を借りて釣り糸をたらせばアジが釣れるだろう。荒川といえばもう一つ、温泉も有名。公衆浴場もあるが、足湯につかってのんびりするのもいい。荒川の集落はこじんまりとしているが歩いてみるのも楽しい。美術大学を卒業した女の子二人組がはじめたゲストハウス「ネドコロノラ」で一泊するのもいいかもしれない。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/spot/61673/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/restaurant/62228/" target="_blank"><img src="../assets/cap_09.jpg"></a>
        <dl>
          <dt>09:五松屋：</dt>
          <dd>五島に行ったら必ず食べたいのは新鮮な魚。事前に刺身のお造りを予約しておけば豪華なパーティとなる。ひょっとしたら地元の人との思いがけない出会いやふれあいもあるかもしれない。五島の魅力は、魚意外の食材も美味しいというところ。五島牛、滋味あふれる野菜、米、いろいろと楽しんでいただきたい。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/restaurant/62228/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://sangosan.net/" target="_blank"><img src="../assets/cap_10.jpg"></a>
        <dl>
          <dt>10:さんごさん：</dt>
          <dd>福江から車で20分ほど。富江にある私設図書館さんごさん。ここは世界中の人たちの「人生の３冊」の寄贈を募っている。この旅では特別にこちらに宿泊。地元の人とのBBQには近所の肉屋で調達した五島牛が。畳で横になったら、併設するCORAL COFFEEのコーヒーと「ごといもポタージュ」を飲みつつ、最終日がスタート。</dd>
          <dd><a href="http://sangosan.net/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://goto.nagasaki-tabinet.com/spot/674/" target="_blank"><img src="../assets/cap_11.jpg"></a>
        <dl>
          <dt>11:大瀬崎灯台：</dt>
          <dd>ロールプレイングゲームの世界のような断崖絶壁とそこにそびえ立つ白い灯台。遠くから眺めるだけでも圧巻だが、可能ならば車を降りて灯台が立つ場所まで歩いてみてほしい。片道20分のハイキングを頑張れば、目の前には水平線。後ろを振り返れば断崖絶壁の岩肌。下を眺めれば岩と青い海。ここでしか体験できない360度の絶景が広がっている。</dd>
          <dd><a href="http://goto.nagasaki-tabinet.com/spot/674/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="https://nagasakigoto.net/" target="_blank"><img src="../assets/cap_12.jpg"></a>
        <dl>
          <dt>12:長崎五島ごと：</dt>
          <dd>「ごといもポタージュ」をつくっている長崎五島 ごとの本店一階は売店になっている。「ごといもポタージュ」や「なんにでもあうカレー」などの自社製品はもちろんのこと、五島うどんやかんころ餅、椿油などの特産品、バラモン凧やゆるキャラグッズまで幅広くお土産物を取り揃えている。今年中にカフェもオープンする予定ということで、空港や港からのアクセスも良いので寄り道してみてはどうだろう。</dd>
          <dd><a href="https://nagasakigoto.net/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
      <li>
        <a href="http://www.gotokanko.jp/contents/access/" target="_blank"><img src="../assets/cap_13.jpg"></a>
        <dl>
          <dt>13:福江空港：</dt>
          <dd>福江島には空港がある。長崎経由・福岡経由いずれも利用できるので、便利である。最終便は19時頃なので、時間を有効に使えるという利点もある。運が良ければ夕陽のタイミングに空を飛べるかもしれない。</dd>
          <dd><a href="http://www.gotokanko.jp/contents/access/" target="_blank">&gt;LINK</a></dd>
        </dl>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MapInfo',
}
</script>

<style scoped>
ul{
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}
li{
  padding: 0 20px;
  margin-bottom: 40px;
  display: block;
  list-style: none;
  flex-basis: 20%;
} 
li > a > img{
  max-width: 100%;
  margin-bottom: 5px;
}
dt{
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.15em;
  line-height: 1.8;
  margin-bottom: 1em;
}
dd{
  font-size: 12px;
  /*font-weight: bold;*/
  letter-spacing: 0.15em;
  line-height: 1.8;
}
@media screen and (max-width:1200px){
  li{
    flex-basis: 25%;
  }
}
@media screen and (max-width:1000px){
  li{
    flex-basis: 33.3%;
  }
}
@media screen and (max-width:800px){
  li{
    flex-basis: 50%;
  }
}
@media screen and (max-width:480px){
  li{
    flex-basis: 100%;
  }
}
</style>
